import "./App.css";
import "./react-github-repos.css";
import { Row, Col, Button } from "react-bootstrap";

import React from "react";
import Header from "./components/Header";
import Content from "./components/Content";
import TitleCard from "./components/TitleCard";
import { Parallax } from "react-parallax";
import Section from "./components/Section";
import "./components/Header";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scrolled: 0,
      scrolledNum: 0,
      opacity: 1,
      bgImage: "assets/images/abstract.jpg",
    };
  }

  fade(start, middle, end, current) {
    let min = middle,
      max = end;
    if (current <= middle) {
      min = middle;
      max = start;
    }
    while (min !== 0) {
      min -= 1;
      max -= 1;
      current -= 1;
    }
    return current / max;
  }
  // eat our own dogfood
  render() {
    return (
      <div className="App">
        <div id="main" className="middle">
          <div
            style={{ /*marginTop: "35vh"*/ marginTop: "10rem", width: "80vw" }}
          >
            <div style={{ display: "flex" }}>
              <div style={{ paddingRight: "1rem" }}>
                <img
                  // id="my-face"
                  style={{ maxHeight: "15rem", borderRadius: "6px" }}
                  src="assets/images/myface.jpeg"
                  alt="jennifer valle"
                />
              </div>
              <div
                className="vert"
                style={{
                  backgroundColor: "white",
                  padding: "1.5rem",
                  borderRadius: "5px",
                }}
              >
                <h1
                  className="titleText"
                  style={{
                    marginTop: "0.5rem",
                    fontFamily: "Alkatra",
                    fontSize: "64px",
                  }}
                >
                  Jennifer Valle
                </h1>
                <h4 className="titleText">
                  Software Developer - Richmond, VA{" "}
                </h4>
                <h5 className="titleText" style={{ fontStyle: "italic" }}>
                  DevSecOps, Automation, and Full Stack Applications
                </h5>
                <div style={{
                  width: "100%"
                }}>
                  <Button
                    onClick={() => {
                      window.open("https://github.com/jvallexm", "_blank");
                    }}
                    style={{
                      backgroundColor: "white",
                      border: "none",
                      marginLeft: "-0.5rem"
                    }}
                  >
                    <i
                      className="fa fa-github"
                      style={{ marginLeft: "5px", color: "black" }}
                      title="View on GitHub"
                    />
                  </Button>
                  <Button
                    onClick={() => {
                      window.open("https://www.linkedin.com/in/jennifer-valle/", "_blank");
                    }}
                    style={{
                      backgroundColor: "white",
                      border: "none"
                    }}
                  >
                    <i
                      className="fa fa-linkedin"
                      style={{ marginLeft: "5px", color: "black" }}
                      title="View on LinkedIn"
                    />
                  </Button>
                </div>
              </div>
            </div>
            <h1
              className="whiteText"
              style={{ marginTop: "5rem", fontStyle: "italic" }}
            >
              Solutions
            </h1>
            <div
              className="vert"
              style={{
                backgroundColor: "white",
                padding: "1.5rem",
                borderRadius: "5px",
                maxWidth: "80vw",
              }}
            >
              <Row>
                <Col>
                  <div>
                    <h1>CRAIG</h1>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <img
                    src="assets/images/craig-page.png"
                    style={{
                      maxWidth: "50%",
                      float: "left",
                      marginRight: "10px",
                    }}
                  />
                  Cloud Resource and Infrastructure-As-code Generator (CRAIG) is
                  a full stack NodeJS and ReactJS web application used to
                  generate Terraform for complex IBM Cloud environments that
                  works out of the box. CRAIG provides a visual interface that
                  makes creating infrastructure components easy and
                  straightforward.
                  <br />
                  <br />
                  The back-end server integrates with IBM Cloud APIs to get the
                  latest Virtual Server images and Kubernetes flavors to
                  generate Terraform. Once a user is finished, they can download
                  Terraform for their environment including a detailed
                  architecture overview. CRAIG also supports IBM Cloud's
                  Terraform-as-a-Service offering Schematics, allowing users to
                  deploy their new code directly from the web interface.
                  <br />
                  <br />I served as the lead developer and designer for CRAIG.
                  Based on my experience working with IBM Cloud Terraform, I
                  wanted to create an easy-to-use web interface to generate
                  Terraform code that strictly follows the
                  Infrastructure-as-Code module, with each resource explictly
                  defined. The Terraform code is generated using{" "}
                  <a
                    href="https://www.npmjs.com/package/json-to-tf"
                    target="_blank"
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    json-to-tf
                  </a>
                  , an NPM package I created to handle the transformation of
                  JSON to Terraform. CRAIG uses a custom state store and
                  generates forms dynamically. This allows for developers to
                  quickly and easily add new components, pages, and features.
                  <br />
                  <br />
                  <Button
                    onClick={() => {
                      window.open("https://www.github.com/IBM/CRAIG", "_blank");
                    }}
                    style={{
                      backgroundColor: "black",
                    }}
                  >
                    CRAIG on GitHub{" "}
                    <i
                      className="fa fa-github"
                      style={{ marginLeft: "5px" }}
                      title="View on GitHub"
                    />
                  </Button>
                  <Button
                    onClick={() => {
                      window.open(
                        "https://github.com/IBM/json-to-tf",
                        "_blank"
                      );
                    }}
                    style={{
                      backgroundColor: "black",
                      marginLeft: "1rem",
                    }}
                  >
                    json-to-tf on GitHub{" "}
                    <i
                      className="fa fa-github"
                      style={{ marginLeft: "5px" }}
                      title="View on GitHub"
                    />
                  </Button>
                </Col>
              </Row>
            </div>
            <div
              className="vert"
              style={{
                backgroundColor: "white",
                padding: "1.5rem",
                borderRadius: "5px",
                maxWidth: "80vw",
                marginTop: "2rem",
              }}
            >
              <Row>
                <Col>
                  <div>
                    <h1>IBM Cloud Secure Landing Zone</h1>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <img
                    src="assets/images/slz-mixed.png"
                    style={{
                      maxWidth: "50%",
                      float: "right",
                      marginRight: "10px",
                    }}
                  />
                  IBM Cloud Secure Landing Zone (SLZ) is a Terraform
                  infrastrcture pattern that allows users to create a custom
                  cloud environment ready for Virtual Server or containerized
                  workloads. As the lead developer for SLZ, I worked to design
                  the Terraform and implement customization features.
                  <br />
                  <br />
                  To deal with the high level of customization supported by the
                  different templates, I created{" "}
                  <a
                    href="https://www.npmjs.com/package/tfxjs"
                    target="_blank"
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    tfxjs
                  </a>
                  , an acceptance and end-to-end testing framework for
                  Terraform. Lessons learned from my time working on Secure
                  Landing Zone and designing a basic front-end cutomization
                  engine informed the design choices for CRAIG.
                  <br />
                  <br />
                  In 2022, I recieved IBM's Outstanding Technical Achievement
                  Award and IBM Entrepreneurship Award for my work on Secure
                  Landing Zone. Secure Landing Zone is currently utilized by
                  organizations across IBM, and the design patterns I pioneered
                  influence how Terraform is used throughout the company.
                  <br />
                  <br />
                  <Button
                    onClick={() => {
                      window.open(
                        "https://github.com/terraform-ibm-modules/terraform-ibm-landing-zone",
                        "_blank"
                      );
                    }}
                    style={{
                      backgroundColor: "black",
                    }}
                  >
                    SLZ on GitHub{" "}
                    <i
                      className="fa fa-github"
                      style={{ marginLeft: "5px" }}
                      title="View on GitHub"
                    />
                  </Button>
                  <Button
                    onClick={() => {
                      window.open("https://github.com/IBM/tfxjs", "_blank");
                    }}
                    style={{
                      backgroundColor: "black",
                      marginLeft: "1rem",
                    }}
                  >
                    tfxjs on GitHub{" "}
                    <i
                      className="fa fa-github"
                      style={{ marginLeft: "5px" }}
                      title="View on GitHub"
                    />
                  </Button>
                </Col>
              </Row>
            </div>
            <h1
              className="whiteText"
              style={{ marginTop: "5rem", fontStyle: "italic" }}
            >
              Skills
            </h1>
            <div
              className="vert"
              style={{
                backgroundColor: "white",
                padding: "1.5rem",
                borderRadius: "5px",
                maxWidth: "80vw",
                marginBottom: "5rem",
                fontFamily: "Victor Mono",
              }}
            >
              NodeJS, ReactJS, HTML, CSS, JavaScript, Terraform, Secure Cloud
              Networking, IAM Access Management, Cloud Monitoring and Alerting,
              Docker, Kubernetes, Red Hat OpenShift, Serverless Computing,
              DevOps Automation, Python, CI/CD Pipelines, API Development,
              MongoDB, Relational Databases (MySQL, PostgreSQL), Back-End Web
              Development, Cloud Engineering, Agile Development, Git, Cloud
              Architecture
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
